import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

const SelectSimple = ({
  data,
  onChange,
  title,
  sx,
  value,
}: {
  data: Array<any>;
  onChange: (event: SelectChangeEvent) => void;
  title: string;
  sx?: any;
  value: string;
}) => {
  return (
    // <Box sx={{ minWidth: 120, mt: 0 }}>
    <FormControl fullWidth size="small" sx={sx}>
      <InputLabel id="demo-simple-select-label">{title}</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value}
        label="Period"
        onChange={onChange}
      >
        {data &&
          data.map((item, index) => {
            return (
              <MenuItem key={index} value={item.value}>
                {item.label}
              </MenuItem>
            );
          })}
      </Select>
    </FormControl>
    // </Box>
  );
};

export default SelectSimple;
